import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const conferences = [
  {
    date: '2026年5月',
    title: '第75回全日本鍼灸学会学術大会',
    location: '岡山',
    note: 'OMFES協賛企業・団体として出展予定',
  },
  {
    date: '2026年5月',
    title: '総会',
    location: '岡山',
    note: '全日本鍼灸学会学術大会付設展示に合わせて開催',
  },
  {
    date: '2026年10月',
    title: '第47回東洋療法学校協会学術大会',
    location: '東京',
    note: '詳細は決まり次第お知らせします',
  },
  {
    date: '2026年10月',
    title: '第21回日本鍼灸師会全国大会',
    location: '神戸',
    note: '詳細は決まり次第お知らせします',
  },
];

const activities = [
  {
    icon: 'ri-links-line',
    title: '業界連携',
    subtitle: 'Industry Collaboration',
    description: '準備中',
    placeholder: true,
  },
  {
    icon: 'ri-broadcast-line',
    title: '普及・広報',
    subtitle: 'Outreach & PR',
    description: '準備中',
    placeholder: true,
  },
  {
    icon: 'ri-discuss-line',
    title: '勉強会・フォーラム',
    subtitle: 'Study Groups & Forums',
    description: '準備中',
    placeholder: true,
  },
];

export default function ActivitiesPage() {
  return (
    <main>
      <Navbar />

      {/* Page Hero */}
      <section className="relative pt-32 pb-20 bg-forest-800 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="/images/activities.jpeg"
            alt="活動内容"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-forest-800/60 to-forest-800/90" />
        </div>
        <div className="absolute right-10 top-1/2 -translate-y-1/2 pointer-events-none opacity-10 hidden lg:block">
          <div className="relative w-48 h-48">
            <div className="absolute inset-0 rounded-full border-2 border-cream-200" />
            <div className="absolute inset-5 rounded-full border border-cream-200" />
            <div className="absolute inset-10 rounded-full border border-cream-200" />
            <div className="absolute inset-16 rounded-full border border-cream-200" />
          </div>
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-cream-400/50" />
            <span className="text-cream-400/60 text-xs font-serif tracking-widest2">ACTIVITIES</span>
          </div>
          <h1 className="text-cream-100 font-serif font-light text-4xl md:text-5xl tracking-wider">
            活動内容
          </h1>
        </div>
      </section>

      {/* Academic Conferences */}
      <section className="bg-cream-100 py-20 md:py-24">
        <div className="max-w-5xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <div className="inline-block border border-forest-600/30 px-6 py-1.5 mb-5">
              <span className="text-forest-600 text-xs font-serif tracking-widest2">ACADEMIC EVENTS</span>
            </div>
            <h2 className="text-forest-800 font-serif font-light text-3xl tracking-wider mb-3">
              学術大会（2026年度予定）
            </h2>
            <p className="text-forest-600/60 text-xs font-serif tracking-wider">
              ※ 内容は変更となる場合があります
            </p>
          </div>

          <div className="space-y-px">
            {conferences.map((event, i) => (
              <div
                key={i}
                className="bg-white border border-cream-300 flex flex-col md:flex-row md:items-center gap-4 md:gap-0 p-6 md:p-0 hover:bg-cream-50 transition-colors duration-200"
              >
                {/* Date */}
                <div className="md:w-36 flex-shrink-0 md:px-6 md:py-5 md:border-r md:border-cream-300">
                  <time className="text-forest-600 text-sm font-serif tracking-wider whitespace-nowrap">
                    {event.date}
                  </time>
                </div>
                {/* Location */}
                <div className="md:w-20 flex-shrink-0 md:px-4 md:py-5 md:border-r md:border-cream-300">
                  <span className="inline-flex items-center gap-1 text-forest-500/70 text-xs font-serif">
                    <i className="ri-map-pin-line text-forest-400/60" />
                    {event.location}
                  </span>
                </div>
                {/* Title & Note */}
                <div className="flex-1 md:px-6 md:py-5">
                  <h3 className="text-forest-800 font-serif text-sm tracking-wider mb-1">{event.title}</h3>
                  <p className="text-forest-500/60 text-xs font-serif">{event.note}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Other Activities */}
      <section className="bg-forest-800 py-20 md:py-24 relative overflow-hidden">
        <div className="absolute left-0 bottom-0 w-64 h-64 rounded-full border border-cream-200/5 -translate-x-1/3 translate-y-1/3 pointer-events-none" />
        <div className="absolute left-0 bottom-0 w-40 h-40 rounded-full border border-cream-200/5 -translate-x-1/3 translate-y-1/3 pointer-events-none" />

        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <div className="inline-block border border-cream-400/30 px-6 py-1.5 mb-5">
              <span className="text-cream-400/60 text-xs font-serif tracking-widest2">OTHER ACTIVITIES</span>
            </div>
            <h2 className="text-cream-100 font-serif font-light text-3xl tracking-wider">
              その他の活動
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {activities.map((item) => (
              <div key={item.title} className="bg-forest-700/50 border border-forest-600/40 p-8">
                <div className="w-12 h-12 flex items-center justify-center border border-cream-400/20 mb-5">
                  <i className={`${item.icon} text-cream-400/70 text-lg`} />
                </div>
                <p className="text-cream-500/50 text-xs font-serif tracking-widest mb-2">{item.subtitle}</p>
                <h3 className="text-cream-200 font-serif font-medium text-lg tracking-wider mb-5">
                  {item.title}
                </h3>
                {item.placeholder ? (
                  <div className="border border-forest-500/30 p-4">
                    <div className="flex items-center gap-2 mb-2">
                      <i className="ri-time-line text-cream-500/40 text-xs" />
                      <span className="text-cream-500/50 text-xs font-serif tracking-wider">準備中</span>
                    </div>
                    <p className="text-cream-500/40 text-xs font-serif leading-relaxed">
                      コンテンツは後日掲載いたします。<br />しばらくお待ちください。
                    </p>
                  </div>
                ) : (
                  <p className="text-cream-400/70 text-sm font-serif leading-relaxed">{item.description}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-cream-200 py-16">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <p className="text-forest-700 font-serif text-base tracking-wider mb-6">
            活動へのご参加・ご協賛についてはお気軽にお問い合わせください
          </p>
          <a
            href="mailto:omfes.info@gmail.com"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-forest-700 text-cream-200 text-sm font-serif tracking-widest hover:bg-forest-600 transition-colors duration-200 rounded-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line" />
            omfes.info@gmail.com
          </a>
        </div>
      </section>

      <Footer />
    </main>
  );
}
